import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardHomeControllerComponent } from './dashboard/presentation/dashboard-home/dashboard-home-controller.component';
import { DashboardDetailsControllerComponent } from './dashboard/presentation/dashboard-details/dashboard-details-controller.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard'},
  // {
  //   path: 'dashboard',
  //   loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardFeatureModule)
  // },
  {
    path: 'dashboard',
    component : DashboardHomeControllerComponent
  },
  {
    path: 'dashboard-details/:topic_id',
    component : DashboardDetailsControllerComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
